import FARSQueueController from "./controller/FarsQueueController";

export default FARSQueueController;